<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<p class="tp-title"><b>Arco Iris</b></p>
<p class="tp-author"><b>Sarah Vap</b></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?74a673f5